import {compact, flatten, get, reduce, map, zipObject, mergeWith, mapValues} from 'lodash/fp'
import {emissions} from '../data/categories'
import {zip} from '../utils'

const modifierToFactors = modifier => modifier
  ?  zipObject(
      modifier.emissions,
      map(() => modifier.amount, modifier.emissions)
    )
  : []

const factorMerger = (oldFactor, newFactor) => oldFactor === undefined
  ? newFactor
  : oldFactor * newFactor

const generateModifier = (question, answer) => {
  switch (question.type) {
    case 'button':
      return get('modifiers', answer)
    case 'radio':
      return get('modifiers', answer)
    case 'zip':
      return get('modifiers', question.answers[zip.getState(answer)])
    case 'number':
      const inputModifiers = map('modifiers', question.answers)
      return answer && flatten(compact(answer.map((input, idx) => isNaN(parseFloat(input))
        ? undefined
        : map(modifier => ({
            ...modifier,
            amount: modifier.amount(parseFloat(input))
          }), inputModifiers[idx])
        : undefined
      )))
    default:
      return undefined
  }
}


const generateModifiers = (questions, answers) =>
  flatten(compact(questions.map((question, idx) => generateModifier(question, answers[idx]))))

export const getUserCo2 = (questions, answers) => {
  const modifiers = generateModifiers(questions, answers)
  const factors = map(modifierToFactors, modifiers)
  const factorVector = reduce(mergeWith(factorMerger), {}, factors)
  const baseCo2Vector = mapValues('co2', emissions)
  return mergeWith(factorMerger, baseCo2Vector, factorVector)
}



// WEBPACK FOOTER //
// ./src/scoring/index.js